import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';
import Select from 'react-select';

const AdvancedSearchFormSelectAttr = ({ input, label, options, placeholder, meta: { touched, error }, clang }) => {
    const handleInputChange = ({ value }) => {
       input.onChange(options.filter(option => option.value === value)[0]);
    };

    return (
        <div className="advanced-search__field--select">
            <label className="advanced-search__field-label" htmlFor={input.name}>
                {label}
                {label && <span>:</span>}
            </label>
            <Select
                {...input}
                onChange={handleInputChange}
                value={input.value || options[0]}
                className="advanced-search__input--select"
                clearable={false}
                placeholder={placeholder}
                deleteRemoves={false}
                backspaceRemoves={false}
                searchable={false}
                options={options}/>
            {touched && (error && <span>{lang[clang].validation[error]}</span>)}
        </div>
    );
};

AdvancedSearchFormSelectAttr.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(AdvancedSearchFormSelectAttr);



// WEBPACK FOOTER //
// ./src/components/advanced-search/AdvancedSearchFormSelectAttr.js